import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

import { useGetUserVectorFoci } from '../../hooks/useVectorFocusService';

import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import VectorFocusListItem from '../../components/VectorFocusListItem/VectorFocusListItem';
import RoundButton from '../../components/RoundButton/RoundButton';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';

import './VectorFoci.scss';

function VectorFoci() {
  const navigate = useNavigate();
  const { authUser, isAuthorized } = useContext(AuthContext);
  const [, userVectorFoci] = useGetUserVectorFoci({
    userId: authUser?.user?.id
  });

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  function handleGoToVectorFocusDetails(vectorFocusId) {
    navigate('/vector-focus-details', {
      state: {
        vectorFocusId
      }
    });
  }

  function handleGoToCreateVectorFocus() {
    navigate('/vector-focus-create');
  }

  return (
    <div className="inner-page vector-foci-page">
      <Header
        pageTitle="Focos do Mosquito"
      />
      <div className="inner-page-content-container">
        {userVectorFoci && (
          <div className="vector-focus-items">
          {
            userVectorFoci.map(item => {
              return (
                <VectorFocusListItem
                  key={item.id}
                  vectorFocus={item}
                  handleGoToVectorFocusDetails={handleGoToVectorFocusDetails} />
              )
            })
          }
        </div>
        )}
      </div>
      <RoundButton
        className="new-focus-button"
        buttonIcon={<AddLocationAltIcon />}
        handleOnClick={handleGoToCreateVectorFocus}
      />
      <BottomMenu />
    </div>
  );
}

export default VectorFoci;
